import styled from 'styled-components'

import Button from 'atoms/Button'
import Typography from 'atoms/Typography'
import CustomSelect from 'atoms/CustomSelect'

export const StyledRoot = styled.div`
  /* border: 3px solid blue; */
  margin-bottom: 50px;
`

export const StyledHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #c7c6c6;
  padding: 10px 0;
  @media (max-width: 456px) {
    flex-direction: column;
  }
`

export const StyledHeaderButton = styled(Button)<{ isReview: boolean }>`
  background-color: transparent;
  font-size: 14px;
  margin-left: 60px;
  text-transform: uppercase;
  @media (max-width: 556px) {
    margin-left: unset;
  }
  ${(p) => (p.isReview ? 'color: #870058; font-weight: 600;' : 'color: #A3A1A1')}
`

export const StyledTotalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 52px;
  margin-top: 20px;
  @media (max-width: 556px) {
    grid-column-gap: 25px;
  }
  @media (max-width: 456px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`

export const StyledTotalBox = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  border: 2px solid #c9c8c8;
  padding: 21px 40px 90px;
  grid-row-gap: 47px;

  h2 {
    align-self: end;
  }
  @media (max-width: 996px) {
    padding: 20px 5px 30px;
    grid-row-gap: 15px;
  }
`

export const StyledTotalIcon = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  grid-column-gap: 27px;

  img {
    width: 101px;
  }

  @media (max-width: 768px) {
    grid-column-gap: 15px;
    img {
      width: 50px;
    }
  }
`

export const StyledTotalText = styled(Typography)`
  font-size: 28px;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`
export const StyledResultBoxText = styled(Typography)`
  font-size: 2rem;
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`

export const StyledRangeContainer = styled.div<{ paddingRight?: any }>`
  margin-top: 20px;
  padding-bottom: 50px;
  border: 2px solid #c9c8c8;
  position: relative;
  padding-right: ${(p) => (p.paddingRight ? p.paddingRight : 42)}px;
  @media (max-width: 768px) {
    padding-right: 0;
    padding-bottom: 10px;
  }
`

export const StyledRangeWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  // @media (max-width: 556px) {
  //   grid-template-columns: 1fr;
  // }
`

export const StyledTitle = styled(Typography)`
  font-size: 28px;
  text-align: center;
  @media (max-width: 1260px) {
    font-size: 20px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const StyledRangeBox = styled.div`
  position: relative;
  text-align: center;
  padding: 0 5px;
  display: grid;
  grid-template-rows: 100px 100px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // flex: 1;
`

export const StyledVerticalLine = styled.div`
  height: 200px;
  border-left: 1px solid #000;
  position: absolute;
  top: 0;
  right: 0;
  @media (max-width: 960px) {
    border-bottom: 1px solid #000;
    border-left: unset;
  }
`

export const StyledChartContainer = styled.div`
  position: relative;
  width: 90%;
  height: 400px;
  margin: 0 auto;
`

export const StyledChartContainerEdit = styled.div`
  position: relative;
  height: 400px;
  width: 67%;
  left: 50px;
`

export const StyledVerticalTypography = styled(Typography)`
  position: absolute;
  left: 10px;
  bottom: 18%;
  transform-origin: 0 0;
  transform: rotate(270deg);
  @media (max-width: 556px) {
    left: 5px;
    bottom: 35%;
    font-size: 14px;
    display: none;
  }
`
export const StyledVerticalTypographyResponsive = styled(Typography)`
  // position: absolute;
  // left: -40px;
  // bottom: 10%;
  // transform-origin: 0 0;
  // transform: rotate(270deg);
  display: none;
  text-align: center;
  font-size: 14px;
  @media (max-width: 556px) {
    left: 0;
    display: block;
  }
`

export const StyledChargeContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  margin-top: 20px;
  @media (max-width: 768px) {
    padding-left: 0;
  }
`

export const StyledScrollContainer = styled.div`
  margin-bottom: 40px;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`

export const StyleChartLabel = styled.div`
  display: flex;
  justify-content: end;
  gap: 7px;
  align-items: center;
  position: absolute;
  right: 40px;
  span {
    font-style: normal;
    // font-weight: 400;
    font-size: 12px;
    line-height: normal;
    color: #000000;
  }
  div {
    width: 12px;
    height: 13px;
    background: #022b12;
  }
`

export const StyledDisclaimerContainer = styled.div`
  p {
    padding: 10px 0;
    color: #333;
    font-size: 20px;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 400;
  }
`

export const StyledInnerFormContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`
export const StyledCustomSelect = styled(CustomSelect)`
  width: 200px;
`
